export function CategoryData() {
  return {
    code: '',
    name: '',
    active: 0,
  }
}
